import React from 'react';

const Nitro = ({ borrow, lend }) => {
    const networks = {
        base: {
            id: '8453',
            USDC: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913'
        },
        solana: {
            id: 'solana',
            USDT: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
            USDC: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'
        },
        polygon: {
            id: '137',
            USDT: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
            USDC: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359'
        },
        optimism: {
            id: '10',
            USDT: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
            USDC: '0x0b2c639c533813f4aa9d7837caf62653d097ff85'
        },
        arbitrum: {
            id: '42161',
            USDT: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
            USDC: '0xaf88d065e77c8cc2239327c5edb3a432268e5831'
        }
    };

    return (
        <iframe id="widget__iframe" height="610px" width="420px"
            src={`https://app.routernitro.com/swap?fromToken=${networks[borrow.name][borrow.coin]}&fromChainId=${networks[borrow.name].id}&toToken=${networks[lend.name][lend.coin]}&toChainId=${networks[lend.name].id}`}
            style={{
                border: 'none',
                borderRadius: '11px',
                boxShadow: '3px 3px 10px 4px rgba(0, 0, 0, 0.05)'
            }}>
        </iframe>
    );
};

export default Nitro;
